import { Helmet } from 'react-helmet'
import {
  RouterProvider,
  ScrollRestoration,
  createHashRouter,
} from 'react-router-dom'

import { GlobalStyle } from 'styles/global'
import { Home } from 'containers/home'
import { AppContextProvider, useAppContext } from 'context/app-context'
import { FiltersContextProvider } from 'context/filters-context'
import { Layout } from 'components/layout'
import { Detail } from 'containers/detail'
import { config } from 'config'

const PageTitle = () => {
  const { strings } = useAppContext()

  return (
    <Helmet htmlAttributes={{ lang: config.language }}>
      <title>{strings.title}</title>
    </Helmet>
  )
}

const router = createHashRouter([
  {
    path: '/',
    element: (
      <Layout>
        <ScrollRestoration />
      </Layout>
    ),
    children: [
      {
        path: '/',
        element: <Home />,
      },
      {
        path: 'detail/:id',
        element: <Detail />,
        errorElement: <Detail />,
      },
    ],
  },
])

function App() {
  return (
    <>
      <GlobalStyle />
      <AppContextProvider>
        <FiltersContextProvider>
          <PageTitle />
          <RouterProvider router={router} />
        </FiltersContextProvider>
      </AppContextProvider>
    </>
  )
}

export default App
